import React from 'react';
import Select from 'react-select';

/**
 * Single-select dropdown for the T&A Role assignment on a user.
 *
 * Props:
 *   availableRoles: { id, codename, name }[]  — from /api/ta-roles/
 *   selectedRoleId: string | null
 *   onChange: (roleId: string | null) => void
 */
const TARoleSelect = ({ availableRoles = [], selectedRoleId = null, onChange }) => {
  const options = [
    { value: null, label: '— None —' },
    ...availableRoles.map((role) => ({
      value: role.id,
      label: role.name,
    })),
  ];

  const value = options.find((opt) => opt.value === selectedRoleId) || options[0];

  return (
    <Select
      classNamePrefix="ta-role-select"
      isClearable={false}
      options={options}
      value={value}
      onChange={(opt) => onChange(opt ? opt.value : null)}
    />
  );
};

export default TARoleSelect;
